/* 布局 */
//前台
import Layout from "@views/layout";

const expertstationedtrendsdirectoryRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
            {
            path: "expertstationedtrendsdirectory",
            name: "EXPERTSTATIONEDTRENDSDIRECTORY",
            meta: {
                title: "MVP动态目录",
                sort: 1,
            },
            component: () => import("@views/business/expertstationedtrendsdirectory/index.vue"),
            redirect: {
                name: "EXPERTSTATIONEDTRENDSDIRECTORY_LIST",
            },
            children: [
                {
                    path: "list",
                    name: "EXPERTSTATIONEDTRENDSDIRECTORY_LIST",
                    meta: {
                        title: "MVP动态目录",
                        sort: 2,
                        keepAlive:true
                    },
                    component: () => import("@views/business/expertstationedtrendsdirectory/list.vue"),
                },
                                {
                    path: "add",
                    name: "EXPERTSTATIONEDTRENDSDIRECTORY_ADD",
                    meta: {
                        title: "新增MVP动态目录",
                        parentPath: '/business/expertstationedtrendsdirectory/list',
                        operate: true,
                    },
                    component: () => import("@views/business/expertstationedtrendsdirectory/form.vue"),
                },
                                                {
                    path: "edit",
                    name: "EXPERTSTATIONEDTRENDSDIRECTORY_EDIT",
                    meta: {
                        title: "编辑MVP动态目录",
                        parentPath: '/business/expertstationedtrendsdirectory/list',
                        operate: true,
                    },
                    component: () => import("@views/business/expertstationedtrendsdirectory/form.vue"),
                },
                                        ],
    },


        ],
};

export default expertstationedtrendsdirectoryRouter;
